export { default } from './TaxIdField';
export type { TaxIdFieldProps } from './TaxIdField';
